module.exports = __webpack_public_path__ + "img/circle-help.64ef2bc3.svg";